var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"text-align":"center","margin-top":"20rem"}},[_vm._v("开发中，敬请期待！")])])}]

export { render, staticRenderFns }